import { render, staticRenderFns } from "./UserDashboard.vue?vue&type=template&id=9973291a&scoped=true&"
import script from "./UserDashboard.vue?vue&type=script&lang=js&"
export * from "./UserDashboard.vue?vue&type=script&lang=js&"
import style0 from "./UserDashboard.vue?vue&type=style&index=0&id=9973291a&prod&scoped=true&lang=css&"
import style1 from "./UserDashboard.vue?vue&type=style&index=1&id=9973291a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9973291a",
  null
  
)

export default component.exports